import { error } from "jquery";

const pRegex = /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[A-Z]).{8,32}$/;
const eRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export function initDropletsTransfer() {
    var types = document.querySelectorAll('.droplets-reciever-type');
    if (types.length > 1 && types[1].checked == true) {
        setDropletsAmount(true)
    }

    document.querySelector('input[type=number]')?.addEventListener('wheel', (e) => { e.preventDefault(); })
    types?.forEach((x) => {
        x.addEventListener('input', () => {
            setDropletsAmount(x.value == "Other");
        })
    })
}
function setDropletsAmount(removeDroplets) {
    const droplets = parseInt(document.querySelector('#droplets-count').innerHTML);
    const minBalance = droplets - 150 < 0 ? 0 : droplets - 150;
    const desc = document.querySelector('.droplets-amount-description-js');
    const input = document.querySelector('.droplets-amount-input-js');

    if (removeDroplets) {
        desc.innerHTML = desc.innerHTML.replace(droplets, minBalance);
        input.max = minBalance;
        input.setCustomValidity(desc.innerHTML);
    } else {
        desc.innerHTML = desc.innerHTML.replace(minBalance, droplets);
        input.max = droplets;
        input.setCustomValidity(desc.innerHTML);
    }
}


export function initAmbasadorLogin() {
    let form = document.querySelector('#login-form');
    form?.addEventListener('keypress', (key) => {
        if (key.key == 'Enter') {
            memberLogin();
        }
    })

    form?.querySelector('button').addEventListener('click', () => {
        memberLogin();
    })
}
function memberLogin() {
    const xhr = new XMLHttpRequest();
    const url = '/umbraco/surface/ambasador/loginUser';
    var username = encodeURIComponent(document.getElementById('email')?.value);
    var password = encodeURIComponent(document.getElementById('password')?.value);
    var rememberPassword = encodeURIComponent(document.getElementById('rememberPswd')?.checked);
    var token = document.querySelector("input[name='__RequestVerificationToken']").value;
    var culture = document.querySelector("input[name='culture']").value;
    const loader = document.querySelector('#login-loader');
    const btn = document.querySelector('#login-btn');

    btn.hide();
    loader.show();

    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", 'application/x-www-form-urlencoded');
    xhr.setRequestHeader("RequestVerificationToken", token)
    xhr.setRequestHeader("Accept-Language", culture)
    xhr.onload = function () {
        if (xhr.status == 200 && this.readyState == 4) {
            var response = JSON.parse(this.responseText);

            if (response.success == true) {
                window.dataLayer = window.dataLayer || []
                dataLayer.push({
                    'event': 'Ambasador login register',
                    'pageLocation': location.href,
                });
                location.href = response.redirectPage;
            }
            else {
                document.getElementById('login-error-message')?.classList.remove('d-none');
                btn.show();
                loader.hide();
            }
        }
    }
    xhr.send(`username=${username}&password=${password}&rememberPassword=${rememberPassword}&culture=${culture}`);
};


export function initLoadMoreQnA() {
    document.querySelector('#button-load-more-qna')?.addEventListener('click', () => {
        const allCount = parseInt(document.querySelector('.total-count')?.textContent);
        const cc = document.querySelector('.current-count');
        const iw = document.querySelector('#q-and-a-items');
        const sm = document.querySelector('.button-wrapper');
        const progressBar = document.querySelector('.progress-bar')
        var currCount = parseInt(document.querySelector('.current-count')?.textContent);

        var nodes = iw?.querySelectorAll('.accordion-item.d-none');
        var newItems = Array.prototype.slice.call(nodes, 0, 6);
        newItems.forEach((x) => x.classList.remove('d-none'));
        currCount += newItems.length;

        cc.innerHTML = currCount;
        progressBar.style.width = `${currCount * 100 / allCount}%`;
        if (currCount >= allCount) { sm.classList.add('d-none') }
    })
}


export function initProfileActivation() {
    var form = document.querySelector('#activate-profile-form');
    form?.querySelectorAll('input')?.forEach((x) => x.addEventListener('input', () => {
        const btn = document.querySelector('#profile-activate-btn');
        const email = document.querySelector('#memberEmail');
        const pass = document.querySelector('#newPassword');
        const pass2 = document.querySelector('#newPasswordRepeat');
        const number = document.querySelector('#memberNumber')

        var emailValid = eRegex.test(email.value);
        var valid = pRegex.test(pass.value);
        var match = pass.value == pass2.value;
        var numValid = parseInt(number.value) > 0 && number.value != null;

        validateField(email, emailValid);
        validateField(pass, valid);
        validateField(pass2, match);
        validateField(number, numValid);
        btn.enableButton(emailValid && valid && match && numValid)
    }))
}

function validateField(e, c) {
    e.classList.toggle('input-validation-error', !c);
    document.querySelector(`#${e.id}Validation`)?.classList.toggle('d-none', c)
}

export function initPasswordReset() {
    document.querySelector('#email-pass-reset')?.addEventListener('input', () => {
        emailInput();
    })

    document.querySelector('#password-set')?.addEventListener('input', () => {
        passwordVal();
    })
    document.querySelector('#password2-set')?.addEventListener('input', () => {
        passwordVal();
    })
}

export function initPasswordChange() {
    const f = document.querySelector('#password-change-form');

    if (f != null) {
        const pageId = f.querySelector('#page-id')?.value;
        const btn = f.querySelector('button');

        btn.addEventListener('click', () => {
            ChangeAmbasadorPassword(pageId, f);
        })
    }
}

export function initDataChange() {
    document.querySelector('#edit-info-btn')?.addEventListener('click', () => {
        toggle(true);
    })

    document.querySelector('#edit-info-btn-cancel')?.addEventListener('click', () => {
        toggle(false);
    })

    document.querySelector('#NumberOfUnderageMembers')?.addEventListener('change', function () {
        var value = document.querySelector('#NumberOfUnderageMembers').value;
        var childNodes = document.querySelectorAll('.child-value');
        for (var i = 0; i < childNodes.length; i++) {
            if (i < value) childNodes[i].classList.remove('d-none')
            else childNodes[i].classList.add('d-none')
        }
    });
}



function toggle(editMode) {
    var form = document.querySelector('#edit-information-form');
    var inputFields = form?.querySelectorAll(["input", "select"]);
    document.querySelectorAll('.form-commands')?.forEach((e) => {
        e.classList.toggle('d-none')
    })

    form.classList.toggle('disabled')

    var unsubscribeBtn = document.querySelector('#UnsubscribeAll');
    unsubscribeBtn?.addEventListener('click', () => {
        inputFields.forEach(f => {
            if (f.id != unsubscribeBtn.id) {
                f.checked = false;
            }
        });
    })

    inputFields?.forEach((e) => {
        if (e.id != "MemberName" && e.id != "MemberSurname" && e.id != "DateOfBirth" && e.id != "DateOfBirth_1" && e.id != "MemberEmail" && e.name != "Gender") {
            e.toggleAttribute('disabled');
        }
        else {
            e.parentElement.querySelectorAll('label').forEach((l) => { l.style.color = 'var(--text-default-disabled)' });
        }
        if (editMode) {
            var t = e.type;
            if (t == 'text') {
                e.value = e.getAttribute('defaultValue');
            } else if (t == 'radio' || t == 'checkbox') {
                e.checked = e.placeholder == 'checked';
            } else if (t == 'select-one') {
                e.querySelectorAll('option').forEach((c) => c.selected = c.classList.contains('selected'))
            }
        };
    })
}

function ChangeAmbasadorPassword(pageId, form) {
    let f = Array.from(form.querySelectorAll('input'));
    var dataToSend = { email: f[0].value, currentPassword: f[1].value, newPassword: f[2].value, newPasswordRepeat: f[3].value, page: pageId, rememberPassword: document.querySelector('#RememberMyPassword').checked }

    fetch('/umbraco/surface/ambasador/changePassword', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
        },
        body: JSON.stringify(dataToSend)
    })
        .then(response => response.json())
        .then(data => {
            var passVal = document.querySelector('#val-CurrentPassword');
            var newPassVal = document.querySelector('#val-NewPassword');
            var newPassRepVal = document.querySelector('#val-NewPasswordRepeatValid');
            var newPassRep = document.querySelector('#val-NewPasswordRepeat');

            passVal.classList.toggle("d-none", data.passwordValid);
            newPassVal.classList.toggle("d-none", data.newPasswordValid);
            newPassRepVal.classList.toggle("d-none", data.newPasswordValid);
            newPassRep.classList.toggle("d-none", data.passwordRepeatValid);

            if (data.success) {
                document.querySelector('#success-section').show();
                document.querySelector('#password-change-form').hide();
            }
        });
};

function emailInput() {
    const btn = document.querySelector('#btn-send-mail');
    const email = document.querySelector('#email-pass-reset');
    const errorMessage = document.querySelector('#mail-not-found')
    errorMessage?.classList.add('d-none');

    var emailValid = eRegex.test(email?.value);

    btn.enableButton(eRegex.test(email?.value))
    email.classList.toggle('input-validation-error', !emailValid)
}

document.querySelector('#btn-send-mail')?.addEventListener('click', () => {
    const culture = document.querySelector('#culture').value;
    const page = document.querySelector('#page').value;
    const successMessage = document.querySelector('#mail-sent-info');
    const errorMessage = document.querySelector('#mail-not-found')
    const email = document.querySelector('#email-pass-reset')?.value;
    const loader = document.querySelector('#loader');
    const btn = document.querySelector('#btn-send-mail');

    loader.show();
    btn.hide();

    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.status == 200) {
            document.querySelector('.bottom')?.hide();
            successMessage?.show();
            btn?.disableButton();
            loader.hide();
        }
        else if (xhr.status == 204) {
            errorMessage?.show();
            btn.show();
            loader.hide();
        }
    }
    xhr.open('GET', `/umbraco/surface/ambasador/sendPasswordResetMail?email=${email}&culture=${culture}&page=${page}`, true);
    xhr.send();
});

function passwordVal() {
    const notValidMessage = document.querySelector('#password-not-valid');
    const notMatchingMessage = document.querySelector('#password-not-matching');
    const btn = document.querySelector('#btn-reset-password');

    var password = document.querySelector('#password-set');
    var password2 = document.querySelector('#password2-set');

    var match = password.value == password2.value;
    var valid = pRegex.test(password.value);

    notValidMessage.classList.toggle('d-none', valid);
    notMatchingMessage.classList.toggle('d-none', match);

    password.classList.toggle('input-validation-error', !valid || !match)
    password2.classList.toggle('input-validation-error', !match || !valid)

    btn.classList.toggle('button--disabled', !valid || !match);
    btn.toggleAttribute('disabled', !valid || !match)
}

// document.querySelectorAll(['#newPassword', '#newPasswordRepeat'])?.forEach((x) => x.addEventListener('input', () => {
//     const p = document.querySelector('#newPasswordValidation');
//     const pr = document.querySelector('#newPasswordRepeatValidation');
//     const newP = document.querySelector('#newPassword').value;
//     const newPR = document.querySelector('#newPasswordRepeat').value;

//     var valid = !pRegex.test(newP);
//     var match = newP == newPR;

//     p.classList.toggle('d-none', valid);
//     pr.classList.toggle('d-none', match);
// }))

document.querySelector('#profile-activate-btn')?.addEventListener('click', function () {
    var results = Array.from(document.querySelector('#profile-activation-form')?.querySelectorAll('input'))?.map((x) => x.value);
    var data = {
        memberNumber: results[0],
        newEmail: results[1],
        newPassword: results[2],
        newPasswordRepeat: results[3],
        isPersistent: document.querySelector('#remember-password')?.checked,
        page: results[5],
        culture: results[4]
    };
    var loader = document.querySelector('#loader');
    var form = document.querySelector('#activate-profile-form');
    var thankYouMessage = document.querySelector('#thank-you-message');
    var notFound = document.querySelector('#activate-profile-error-message');
    var alreadyActivated = document.querySelector('#activate-profile-error-message-2');
    var serverError = document.querySelector('#activation-server-error');

    notFound.hide();
    alreadyActivated.hide();
    serverError.hide();
    loader.show();
    form.hide();

    fetch('/umbraco/surface/ambasador/activateProfile', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
        },
        body: JSON.stringify(data)
    })
        .then(d => {
            loader.hide();

            if (d.status == 200) thankYouMessage.show();
            else {
                form.show();
                if (d.status == 400) alreadyActivated.show();
                else if (d.status == 404) notFound.show();
                else serverError.show();
            }
        });
})


HTMLElement.prototype.hide = function () {
    this.classList.add('d-none');
};

HTMLElement.prototype.show = function () {
    this.classList.remove('d-none');
};

HTMLElement.prototype.enableButton = function (enable) {
    this.classList.toggle('button--disabled', !enable);
    this.classList.toggle('button--secondary', enable);
    this.toggleAttribute('disabled', !enable)
};